export default __webpack_public_path__ + "static/media/tomb.f95169da.png";